import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    CheckCircleIcon,
    ChevronRightIcon,
    colors,
    RadioButtonUncheckedIcon
} from "@dotnet/telematics-design-system";

import ListChoice from "components/DesignComponents/ListChoice";
import { STEP_GROUP } from "components/TutorialMode/types";
import TutorialContext from "context/tutorial/tutorialContext";
import { useMediaQueries } from "shared";

import GoBack from "./GoBack";
import { TutorialProps } from "./types";

const Tutorials = ({ setContent, closeMenu }: TutorialProps) => {
    const { setTutorialOpen } = useContext(TutorialContext);

    const { green600, textDisabled } = colors;

    const { t } = useTranslation();
    const { toMd } = useMediaQueries();

    const startTutorial = (stepGroup: STEP_GROUP) => {
        setTutorialOpen(true, 0, stepGroup);
        closeMenu();
    };

    const checkIfTutorialCompleted = (tutorialName: STEP_GROUP) => {
        return localStorage.getItem(tutorialName) === "true" ? (
            <CheckCircleIcon css={css({ color: green600 })} />
        ) : (
            <RadioButtonUncheckedIcon
                css={css({
                    color: textDisabled
                })}
            />
        );
    };

    return (
        <div
            css={css({
                marginTop: toMd ? "-48px" : "0"
            })}
        >
            <GoBack setContent={setContent} />

            <ListChoice
                title={t("Filter##company selector")}
                iconLeft={checkIfTutorialCompleted(
                    STEP_GROUP.TutorialCompanySelector
                )}
                iconRight={<ChevronRightIcon />}
                onClick={() =>
                    startTutorial(STEP_GROUP.TutorialCompanySelector)
                }
            />

            <ListChoice
                title={t("General##task groups")}
                iconLeft={checkIfTutorialCompleted(
                    STEP_GROUP.TutorialTaskGroups
                )}
                iconRight={<ChevronRightIcon />}
                onClick={() => startTutorial(STEP_GROUP.TutorialTaskGroups)}
            />
        </div>
    );
};

export default Tutorials;
